import { useForm, ValidationError } from '@formspree/react';
import React, { Component } from 'react';
import { trackAction } from '../lib/firebase';
import '../styles/WhatsAppPOC.css';

// Formspree check on https://formspree.io/f/xeepgrgw

const WORKER_URL = 'https://rakeen-whatsapp-poc.thamer-21d.workers.dev';
const SANDBOX_NUMBER = '+14155238886';
const JOIN_CODE = 'join cake-read';
const WHATSAPP_CONTACT = '966505773806';

const STATUS_FLOW = [
  'inquiry',
  'quoted',
  'confirmed',
  'processing',
  'ready',
  'delivered',
];
const STATUS_LABELS = {
  inquiry: 'استفسار',
  quoted: 'عرض سعر',
  confirmed: 'تأكيد',
  processing: 'تجهيز',
  ready: 'جاهز',
  delivered: 'تسليم',
};

// ─── Signup Form ───

function SignupForm() {
  const [state, handleSubmit] = useForm('xeepgrgw');
  const [errors, setErrors] = React.useState({});
  const [formLoadTime] = React.useState(Date.now());

  const validatePhone = (phone) => {
    const cleaned = phone.replace(/\s|-/g, '');
    if (!/^(05|5|9665|\+9665)\d{8}$/.test(cleaned)) {
      return 'رقم الجوال غير صحيح — يجب أن يبدأ بـ 05';
    }
    return '';
  };

  const validateName = (name) => {
    if (name.trim().length < 2) return 'الرجاء إدخال الاسم';
    return '';
  };

  const validateBusiness = (business) => {
    if (business.trim().length < 2) return 'الرجاء إدخال اسم الشركة';
    return '';
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const form = e.target;
    const name = form.elements.name.value;
    const phone = form.elements.phone.value;
    const business = form.elements.business.value;

    // Honeypot — if filled, it's a bot
    if (form.elements.website && form.elements.website.value) return;

    // Time check — if submitted within 3 seconds of page load, it's a bot
    if (Date.now() - formLoadTime < 3000) return;

    const newErrors = {};
    const nameErr = validateName(name);
    const phoneErr = validatePhone(phone);
    const businessErr = validateBusiness(business);

    if (nameErr) newErrors.name = nameErr;
    if (phoneErr) newErrors.phone = phoneErr;
    if (businessErr) newErrors.business = businessErr;

    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      trackAction('signup_submit', { source: 'saree_landing' });
      handleSubmit(e);
    }
  };

  const clearError = (field) => {
    if (errors[field]) {
      setErrors((prev) => {
        const n = { ...prev };
        delete n[field];
        return n;
      });
    }
  };

  if (state.succeeded) {
    return (
      <div className='wp-form-success'>
        <div className='wp-form-success-icon'>✓</div>
        <p className='wp-form-success-ar'>شكراً لتسجيلك! سنتواصل معك قريباً.</p>
      </div>
    );
  }

  return (
    <form className='wp-form' onSubmit={onSubmit} noValidate>
      <input type='hidden' name='source' value='whatsapp-poc' />
      <input type='text' name='website' style={{ position: 'absolute', left: '-9999px', tabIndex: -1 }} autoComplete='off' />
      <div className='wp-form-row'>
        <div className='wp-form-field'>
          <label>الاسم</label>
          <input
            name='name'
            type='text'
            required
            placeholder='محمد احمد'
            onChange={() => clearError('name')}
            className={errors.name ? 'wp-input-error' : ''}
          />
          {errors.name && <span className='wp-field-error'>{errors.name}</span>}
        </div>
        <div className='wp-form-field'>
          <label>رقم الجوال</label>
          <input
            name='phone'
            type='tel'
            required
            placeholder='05XXXXXXXX'
            onChange={() => clearError('phone')}
            className={errors.phone ? 'wp-input-error' : ''}
          />
          {errors.phone && (
            <span className='wp-field-error'>{errors.phone}</span>
          )}
        </div>
      </div>
      <div className='wp-form-field'>
        <label>اسم الشركة</label>
        <input
          name='business'
          type='text'
          required
          placeholder='اسم الشركة أو المصنع'
          onChange={() => clearError('business')}
          className={errors.business ? 'wp-input-error' : ''}
        />
        {errors.business && (
          <span className='wp-field-error'>{errors.business}</span>
        )}
      </div>
      <div className='wp-form-field'>
        <label>المدينة</label>
        <input name='city' type='text' placeholder='الدمام، الرياض، جدة...' />
      </div>
      <button
        type='submit'
        className='wp-form-submit'
        disabled={state.submitting}
      >
        {state.submitting
          ? '...جاري الإرسال'
          : 'ابدأ الآن — أسبوعين تجربة مجانية'}
      </button>
      <ValidationError errors={state.errors} />
    </form>
  );
}

// ─── Order Card ───

function OrderCard({ order, onAdvance, onReply, onQuote, advancing, sending }) {
  const [replyText, setReplyText] = React.useState('');
  const [showQuoteForm, setShowQuoteForm] = React.useState(false);
  const [quoteData, setQuoteData] = React.useState({
    unitPrice: '',
    quantity: '',
    delivery: '3-5 أيام عمل',
    notes: '',
  });

  const currentIndex = STATUS_FLOW.indexOf(order.status);
  const nextStatus = STATUS_FLOW[currentIndex + 1];
  const isOrderType =
    order.tag && (order.tag.includes('عرض سعر') || order.tag.includes('صيانة'));
  const canQuote = isOrderType && order.status === 'inquiry';

  const handleReply = () => {
    if (!replyText.trim()) return;
    onReply(order.id, replyText.trim());
    setReplyText('');
  };

  const handleQuote = () => {
    if (!quoteData.unitPrice || !quoteData.quantity) return;
    onQuote(order.id, {
      unitPrice: parseFloat(quoteData.unitPrice),
      quantity: parseInt(quoteData.quantity, 10),
      delivery: quoteData.delivery,
      notes: quoteData.notes,
    });
    setShowQuoteForm(false);
    setQuoteData({
      unitPrice: '',
      quantity: '',
      delivery: '3-5 أيام عمل',
      notes: '',
    });
  };

  return (
    <div className='wp-order-card'>
      <div className='wp-order-header'>
        <span className='wp-order-phone'>{order.phone}</span>
        <span className='wp-order-id'>#{order.id}</span>
        <span className='wp-order-tag'>{order.tag}</span>
      </div>

      <div className='wp-messages'>
        {order.messages.map((msg, i) => (
          <div key={i} className={`wp-msg wp-msg-${msg.sender}`}>
            <span className='wp-msg-icon'>
              {msg.sender === 'customer' ? '👤' : '🤖'}
            </span>
            <span className='wp-msg-text'>{msg.content}</span>
          </div>
        ))}
      </div>

      {/* Status bar — only for order-type conversations */}
      {isOrderType && (
        <div className='wp-status-track'>
          {STATUS_FLOW.map((s, i) => (
            <div
              key={s}
              className={`wp-status-step ${i <= currentIndex ? 'active' : ''}`}
            >
              <div
                className={`wp-status-dot ${i <= currentIndex ? 'wp-dot-active' : 'wp-dot-pending'}`}
              />
              <span className='wp-status-label'>{STATUS_LABELS[s]}</span>
            </div>
          ))}
        </div>
      )}

      {/* Action buttons for order-type conversations */}
      {isOrderType && (
        <div className='wp-actions'>
          {canQuote && !showQuoteForm && (
            <button
              className='wp-quote-btn'
              onClick={() => setShowQuoteForm(true)}
            >
              📋 أرسل عرض سعر
            </button>
          )}
          {nextStatus && !canQuote && (
            <button
              className='wp-advance-btn'
              onClick={() => onAdvance(order.id)}
              disabled={advancing === order.id}
            >
              {advancing === order.id
                ? '...جاري الإرسال'
                : `⬅ المرحلة التالية: ${STATUS_LABELS[nextStatus]}`}
            </button>
          )}
          {!nextStatus && (
            <div className='wp-order-complete'>✅ تم إكمال الطلب</div>
          )}
        </div>
      )}

      {/* Quote form */}
      {showQuoteForm && (
        <div className='wp-quote-form'>
          <h4>📋 عرض سعر — #{order.id}</h4>
          <div className='wp-quote-info'>
            <span>المنتج: {order.product}</span>
            <span>التفاصيل: {order.specs}</span>
          </div>
          <div className='wp-quote-fields'>
            <div className='wp-quote-row'>
              <div className='wp-quote-field'>
                <label>سعر الوحدة (ريال)</label>
                <input
                  type='number'
                  value={quoteData.unitPrice}
                  onChange={(e) =>
                    setQuoteData({ ...quoteData, unitPrice: e.target.value })
                  }
                  placeholder='85'
                />
              </div>
              <div className='wp-quote-field'>
                <label>الكمية</label>
                <input
                  type='number'
                  value={quoteData.quantity}
                  onChange={(e) =>
                    setQuoteData({ ...quoteData, quantity: e.target.value })
                  }
                  placeholder='100'
                />
              </div>
            </div>
            {quoteData.unitPrice && quoteData.quantity && (
              <div className='wp-quote-total'>
                الإجمالي:{' '}
                {(
                  parseFloat(quoteData.unitPrice || '0') *
                  parseInt(quoteData.quantity || '0', 10)
                ).toLocaleString()}{' '}
                ريال
              </div>
            )}
            <div className='wp-quote-field'>
              <label>مدة التوصيل</label>
              <input
                type='text'
                value={quoteData.delivery}
                onChange={(e) =>
                  setQuoteData({ ...quoteData, delivery: e.target.value })
                }
              />
            </div>
            <div className='wp-quote-field'>
              <label>ملاحظات (اختياري)</label>
              <input
                type='text'
                value={quoteData.notes}
                onChange={(e) =>
                  setQuoteData({ ...quoteData, notes: e.target.value })
                }
                placeholder='ضمان سنة، شحن مجاني...'
              />
            </div>
          </div>
          <div className='wp-quote-btns'>
            <button
              className='wp-quote-send'
              onClick={handleQuote}
              disabled={sending}
            >
              {sending ? '...جاري الإرسال' : 'إرسال العرض'}
            </button>
            <button
              className='wp-quote-cancel'
              onClick={() => setShowQuoteForm(false)}
            >
              إلغاء
            </button>
          </div>
        </div>
      )}

      {/* Reply input — always visible */}
      <div className='wp-reply-box'>
        <input
          type='text'
          className='wp-reply-input'
          value={replyText}
          onChange={(e) => setReplyText(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && handleReply()}
          placeholder='اكتب رد...'
          dir='rtl'
        />
        <button
          className='wp-reply-send'
          onClick={handleReply}
          disabled={!replyText.trim() || sending}
        >
          إرسال
        </button>
      </div>
    </div>
  );
}

// ─── Main Page ───

class WhatsAppPOC extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orders: [],
      loading: true,
      error: null,
      advancing: null,
      sending: false,
    };
  }

  isSaree() {
    return window.location.pathname.startsWith('/saree');
  }

  componentDidMount() {
    document.title = this.isSaree()
      ? 'ركين — سريع | Rakeen Saree'
      : 'ركين — نظام واتساب التلقائي | Rakeen WhatsApp Auto-Menu';
    this.fetchOrders();
    this.interval = setInterval(() => this.fetchOrders(), 5000);
  }

  componentWillUnmount() {
    if (this.interval) clearInterval(this.interval);
  }

  fetchOrders = async () => {
    try {
      const params = new URLSearchParams(window.location.search);
      const demoParam = params.get('demo') === '1' ? '?demo=1' : '';
      const res = await fetch(`${WORKER_URL}/api/conversations${demoParam}`, {
        cache: 'no-store',
      });
      if (res.ok) {
        const orders = await res.json();
        this.setState({ orders, loading: false, error: null });
      }
    } catch (err) {
      this.setState({ loading: false, error: 'تعذر الاتصال بالخادم' });
    }
  };

  manualRefresh = () => {
    this.setState({ loading: true });
    this.fetchOrders();
  };

  advanceOrder = async (orderId) => {
    this.setState({ advancing: orderId });
    try {
      const res = await fetch(`${WORKER_URL}/api/orders/${orderId}/advance`, {
        method: 'POST',
      });
      if (res.ok) {
        await this.fetchOrders();
      }
    } catch (err) {
      console.error('Advance failed:', err);
    }
    this.setState({ advancing: null });
  };

  replyToOrder = async (orderId, message) => {
    this.setState({ sending: true });
    try {
      await fetch(`${WORKER_URL}/api/orders/${orderId}/reply`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ message }),
      });
      await this.fetchOrders();
    } catch (err) {
      console.error('Reply failed:', err);
    }
    this.setState({ sending: false });
  };

  sendQuote = async (orderId, quoteData) => {
    this.setState({ sending: true });
    try {
      await fetch(`${WORKER_URL}/api/orders/${orderId}/quote`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(quoteData),
      });
      await this.fetchOrders();
    } catch (err) {
      console.error('Quote failed:', err);
    }
    this.setState({ sending: false });
  };

  clearAll = async () => {
    if (!window.confirm('مسح جميع المحادثات؟')) return;
    await fetch(`${WORKER_URL}/api/conversations`, { method: 'DELETE' });
    await this.fetchOrders();
  };

  render() {
    const { orders, loading, advancing, sending } = this.state;
    const whatsappJoinUrl = `https://wa.me/${SANDBOX_NUMBER.replace('+', '')}?text=${encodeURIComponent(JOIN_CODE)}`;

    return (
      <div className='wp-root'>
        {/* Nav */}
        <nav className='wp-nav'>
          <div className='wp-nav-inner'>
            <a href='/' className='wp-nav-logo'>
              <img
                src='/images/rakeen-logo.png'
                alt='Rakeen'
                className='wp-nav-logo-img'
              />
              <span className='wp-nav-logo-text'>{this.isSaree() ? 'سريع' : 'متر مربع'}</span>
            </a>
            <div className='wp-nav-links'>
              <a href='#demo' className='wp-nav-link'>
                التجربة
              </a>
              <a href='#live' className='wp-nav-link'>
                المحادثات
              </a>
              <a href='/saree/dashboard' className='wp-nav-link wp-nav-cta-secondary' onClick={() => trackAction('cta_click', { label: 'dashboard', source: 'saree_nav' })}>
                لوحة التحكم
              </a>
              <a href='#signup' className='wp-nav-link wp-nav-cta' onClick={() => trackAction('cta_click', { label: 'signup', source: 'saree_nav' })}>
                ابدأ الآن
              </a>
            </div>
          </div>
        </nav>

        {/* Hero */}
        <section className='wp-hero'>
          <div className='wp-hero-content'>
            <span className='wp-hero-badge'>
              ⚙️ للمصانع والموردين الصناعيين
            </span>
            <h1 className='wp-hero-title'>
              جرّب نظام الرد التلقائي على واتساب
            </h1>
            <p className='wp-hero-subtitle'>
              شاهد كيف يتم الرد على عملاءك تلقائياً وتتبع طلباتهم من الاستفسار
              إلى التسليم
            </p>
          </div>
        </section>

        {/* How to Try */}
        <section className='wp-steps' id='demo'>
          <div className='wp-section-inner'>
            <h2 className='wp-section-title'>جرّب الآن — 3 خطوات</h2>
            <div className='wp-steps-grid'>
              <div className='wp-step-card'>
                <div className='wp-step-number'>1</div>
                <h3>افتح واتساب</h3>
                <p>أرسل الرسالة التالية:</p>
                <code className='wp-code'>{JOIN_CODE}</code>
                <p>إلى الرقم:</p>
                <code className='wp-code'>{SANDBOX_NUMBER}</code>
              </div>
              <div className='wp-step-card'>
                <div className='wp-step-number'>2</div>
                <h3>أرسل رسالة</h3>
                <p>بعد التأكيد، أرسل أي رسالة:</p>
                <code className='wp-code'>السلام عليكم</code>
                <p>وشاهد القائمة التلقائية</p>
              </div>
              <a href='#live' className='wp-step-card wp-step-link'>
                <div className='wp-step-number'>3</div>
                <h3>تابع الطلب / المحادثة</h3>
                <p>اختر من القائمة وشاهد طلبك أو محادثتك تظهر هنا مباشرة 👇</p>
                <p>اضغط على "المرحلة التالية" لإرسال تحديث للعميل</p>
              </a>
            </div>
            <div className='wp-steps-cta'>
              <a
                href={whatsappJoinUrl}
                target='_blank'
                rel='noopener noreferrer'
                className='wp-btn-whatsapp'
                onClick={() => trackAction('whatsapp_join', { source: 'saree_landing' })}
              >
                جرّب الآن عبر واتساب
              </a>
            </div>
          </div>
        </section>

        {/* Live Conversations */}
        <section className='wp-live' id='live'>
          <div className='wp-section-inner'>
            <div className='wp-live-header'>
              <h2 className='wp-section-title'>
                📺 المحادثات والطلبات المباشرة
              </h2>
              <div className='wp-live-controls'>
                <button className='wp-refresh-btn' onClick={this.clearAll}>
                  مسح الكل 🗑️
                </button>
                <button className='wp-refresh-btn' onClick={this.manualRefresh}>
                  تحديث 🔄
                </button>
                <div className='wp-live-indicator'>
                  <span className='wp-live-dot' />
                  <span>يتحدث تلقائياً</span>
                </div>
              </div>
            </div>

            {loading && <p className='wp-loading'>جاري التحميل...</p>}

            {!loading && orders.length === 0 && (
              <div className='wp-empty'>
                <p>لا توجد محادثات او طلبات بعد</p>
                <p>جرّب الآن عبر واتساب وشاهد طلبك يظهر هنا! 👆</p>
              </div>
            )}

            <div className='wp-orders-grid'>
              {orders.map((order) => (
                <OrderCard
                  key={order.id}
                  order={order}
                  onAdvance={this.advanceOrder}
                  onReply={this.replyToOrder}
                  onQuote={this.sendQuote}
                  advancing={advancing}
                  sending={sending}
                />
              ))}
            </div>
          </div>
        </section>

        {/* Features */}
        <section className='wp-features'>
          <div className='wp-section-inner'>
            <h2 className='wp-section-title'>المميزات</h2>
            <div className='wp-features-grid'>
              <div className='wp-feature-card'>
                <span className='wp-feature-icon'>📋</span>
                <h3>قائمة تلقائية</h3>
                <p>
                  عميلك يرسل رسالة ويشوف قائمة خيارات فورية — عروض أسعار،
                  استفسارات، صيانة — بدون تدخل موظف
                </p>
              </div>
              <div className='wp-feature-card'>
                <span className='wp-feature-icon'>📦</span>
                <h3>تتبع الطلبات</h3>
                <p>
                  تابع كل طلب من الاستفسار إلى التسليم. عميلك يستلم تحديثات
                  واتساب تلقائية على كل مرحلة
                </p>
              </div>
              <div className='wp-feature-card'>
                <span className='wp-feature-icon'>👨‍💼</span>
                <h3>لوحة تحكم للفريق</h3>
                <p>
                  كل المحادثات والطلبات في مكان واحد. وزّع المحادثات على فريقك
                  وتابع أداء كل موظف
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Signup */}
        <section className='wp-signup' id='signup'>
          <div className='wp-section-inner'>
            <h2 className='wp-section-title'>مهتم؟ ابدأ تجربتك المجانية</h2>
            <p className='wp-signup-subtitle'>أسبوعين تجربة مجانية</p>
            <SignupForm />
            <div className='wp-signup-alt'>
              <span>أو تواصل مباشرة:</span>
              <a
                href={`https://wa.me/${WHATSAPP_CONTACT}?text=${encodeURIComponent('مهتم بنظام الرد التلقائي على واتساب')}`}
                target='_blank'
                rel='noopener noreferrer'
                className='wp-btn-whatsapp-sm'
              >
                تواصل واتساب
              </a>
            </div>
          </div>
        </section>

        {/* Footer */}
        <footer className='wp-footer'>
          <div className='wp-footer-inner'>
            <span>&copy; {new Date().getFullYear()} Rakeen — {this.isSaree() ? 'سريع' : 'متر مربع'}</span>
            <div className='wp-footer-links'>
              <a href='/privacy'>Privacy</a>
              <a href='/terms'>Terms</a>
              <a href='/contact'>Contact</a>
            </div>
          </div>
        </footer>
      </div>
    );
  }
}

export default WhatsAppPOC;
